import { Body } from './Body'
import { Footer } from './Footer'
import { Header } from './Header'
import { Screen } from './Screen'
import { Toolbar } from './Toolbar'

export const LevelPlay = {
  Screen,
  Body,
  Footer,
  Header,
  Toolbar
}
